import { render } from "./ELECTED_VAL_RBTS.vue?vue&type=template&id=4a871629"
import script from "./ELECTED_VAL_RBTS.vue?vue&type=script&lang=js"
export * from "./ELECTED_VAL_RBTS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__